import {AxiosInstance} from "axios";
import ComponentRepositoryInterface from "@/services/Bug-report/Settings/interfaces/component.repository";
import {ComponentEntity, CreateComponentDTO, UpdateComponentDTO} from "@fenix/bug-report-entities/bug-report-entities";

export default class ComponentRepository implements ComponentRepositoryInterface {
  constructor(private readonly axios: AxiosInstance) {
  }

  async create(DTOs: CreateComponentDTO[]): Promise<ComponentEntity[]> {
    const url = 'bug-report/bugs/component';
    const res = await this.axios.post(url, DTOs);

    return res.data;
  }

  async getOne(id: number, relations?: string[]): Promise<ComponentEntity> {
    const url = `bug-report/bugs/component/${id}${relations && relations?.length ? `?relations=${relations.toString()}` : ''}`;
    const res = await this.axios.get(url);

    return res.data;
  }

  async updateOne(id: number, dto: UpdateComponentDTO): Promise<ComponentEntity> {
    const url = `bug-report/bugs/component/${id}`;
    const res = await this.axios.patch(url, dto);

    return res.data
  }

  async deleteOne(id: number): Promise<void> {
    const url = `bug-report/bugs/component/${id}`;
    await this.axios.delete(url);
  }

  async getAll(page?: number, take?: number): Promise<ComponentEntity[]> {
    const url = `bug-report/bugs/component?page=${page ?? ''}&take=${take ?? ''}`;
    const res = await this.axios.get(url);

    return res.data;
  }
}
